import axios from "axios";
import { appConstants } from "./appConstants";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { generateToken } from "./generic";
import { CurrencyAction } from "ReduxReducers/currencyReducer";
import { downloadWebsiteDocument } from "./documentPdf";

let axiosConfig = {
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
  },
};
let id;
if (JSON.parse(sessionStorage.getItem("LOGIN_DETAILS")) !== null) {
  id = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))._id;
}

/*<====================================BU DASHBOARD=========================================>*/
export const getDefaultSetting = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "defaultSettings/fetchDefaultSettingonDashboard",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getBusinessUserDashboardData===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getBusinessUserDashboardData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "dashboard/fetchBusinessUserDashboardData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getBusinessUserDashboardData===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const getBUDashboardInvoicesOwedToYouGraphDetails = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL +
        "dashboard/fetchBUDashboardInvoicesOwedToYouGraphDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getBUDashboardInvoicesOwedToYouGraphDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getBUDashboardBillsYouNeedToPayGraphs = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL +
        "dashboard/fetchBUDashboardBillsYouNeedToPayGraphs",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getBUDashboardBillsYouNeedToPayGraphs===>", error);
    });
};
export const getBusinessUserDasboardLineChartDataOrderRevenue = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL +
        "dashboard/fetchBusinessUserDasboardLineChartDataOrderRevenue",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error getBusinessUserDasboardLineChartDataOrderRevenue===>",
        error
      );
    });
};

export const getBusinessUserDasboardActivityData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "dashboard/fetchBusinessUserDasboardActivityData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getBusinessUserDasboardActivityData===>", error);
    });
};
export const getDasboardBusinessUserGridData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "dashboard/fetchDasboardBusinessUserGridData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getDasboardBusinessUserGridData===>", error);
    });
};

/*<=====================================CUSTOMER========================================>*/
export const fetchCustom = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/fetchCustomer", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchCustomer===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const deleteCustomerRecords = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/deleteCustomer", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete CustomerRecords===>", error.message);
    });
};
export const addCustomerData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/addCustomer", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete addCustomerData===>", error.message);
    });
};
export const updateCustomerData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "customer/updateCustomer", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete updateCustomerData===>", error.message);
    });
};
export const getCustomerByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "customer/fetchCustomerById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete getCustomerByID===>", error.message);
    });
};

/*<====================================TOKEN GENERATE===========================================>*/
export const generateTokenID = async (values, dispatch, callBack) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "login/generateTokenID", { id: values })
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("error delete generateTokenID===>", error.message);
    });
};

/*<===================================== COUNTRY STATE=========================================>*/
export const getCountry = async (callBack) => {
  await axios
    .get(appConstants.baseURL + "countryState/fetchCountry")
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete generateTokenID===>", error.message);
    });
};
export const getState = async (callBack) => {
  await axios
    .get(appConstants.baseURL + "countryState/fetchState")
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete getCountry===>", error.message);
    });
};
/*<====================================PARAMETER LIST ==========================================>*/
export const getParameterListName = async (callBack) => {
  await axios
    .get(appConstants.baseURL + "parameter/fetchParameterListName")
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error getParameterListName===>", error.message);
    });
};

/*<===========================================EMPLOYEE=========================================>*/
export const getEmployee = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/fetchEmployee", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getEmployee===>", error.message);
    });
};

export const deleteEmployeeData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/deleteEmployee", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error deleteEmployeeData===>", error.message);
    });
};
export const getEmployeeByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "employee/fetchEmployeeById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getEmployeeByID===>", error.message);
    });
};
export const addEmployeeData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/addEmployee", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error addEmployeeData===>", error.message);
    });
};
export const updateEmployeeData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/updateEmployee", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error updateEmployeeData===>", error.message);
    });
};
export const getEmployeeNameList = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "employee/fetchEmployeeNameList",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getEmployeeNameList===>", error.message);
    });
};

export const getDocumentById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "employee/fetchDocumentById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      console.log("asdasda", error.message);
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getDocumentById===>", error.message);
    });
};
export const getDocument = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/fetchDocument", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getDocument===>", error.message);
    });
};

export const deleteSelectedDocument = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/deleteDocument", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error deleteSelectedDocument===>", error.message);
    });
};

export const saveDocument = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/addDocument", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error saveDocument===>", error.message);
    });
};

export const updateDocumentByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "employee/updateDocument", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error updateDocumentByID===>", error.message);
    });
};

/*<===================================== WAREHOUSE===================================>*/

export const getWarehouseList = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "warehouse/fetchWarehouseList",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getWarehouseList===>", error.message);
    });
};

/*<=======================================VEHICLE======================================>*/

export const deleteSelectedVehicle = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "vehicle/deleteVehicle", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error deleteSelectedVehicle===>", error.message);
    });
};
export const getVehicle = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "vehicle/fetchVehicle", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getVehicle===>", error.message);
    });
};

export const updateVehicleByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "vehicle/updateVehicle", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error updateVehicleByID===>", error.message);
    });
};
export const saveVehicle = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "vehicle/addVehicle", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error saveVehicle===>", error.message);
    });
};
export const getVehicleDocument = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "vehicle/fetchVehicleDocument",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getVehicleDocument===>", error.message);
    });
};

export const getVehicleById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "vehicle/fetchVehicleById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getVehicleById===>", error.message);
    });
};

export const deleteSelectedVehicleDocument = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "vehicle/deleteVehicleDocument",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error deleteSelectedVehicleDocument===>", error.message);
    });
};

export const saveVehicleDocument = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "vehicle/addVehicleDocument",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  saveVehicleDocument===>", error.message);
    });
};

export const updateVehicleDocumentByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "vehicle/updateVehicleDocument",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateVehicleDocumentByID===>", error.message);
    });
};

export const getVehicleDocumentById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "vehicle/fetchVehicleDocumentById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getVehicleDocumentById===>", error.message);
    });
};

/*<======================================BILLING===================================> */

export const getSubscriptionPlans = async (callBack) => {
  axios
    .get(appConstants.baseURL + "billing/fetchSubscriptionPlans")
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error  getSubscriptionPlans===>", error.message);
    });
};

export const fetchCreditsData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "billing/fetchCredits", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getCards===>", error.message);
    });
};

export const getCards = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "billing/fetchcards", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getCards===>", error.message);
    });
};

export const getCurrentPlanDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "billing/fetchCurrentPlanDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getCurrentPlanDetails===>", error.message);
    });
};

export const changeToSubscriptionPlan = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "billing/changeSubscriptionPlan",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  changeSubscriptionPlan===>", error.message);
    });
};

export const changeToBasicPlan = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "billing/changeToBasic", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  changeToBasicPlan===>", error.message);
    });
};

export const getPaymentIntent = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "billing/fetchPaymentIntent",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getPaymentIntent===>", error.message);
    });
};

export const paymentWithSavedCard = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "billing/payWithSavedCard",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  paymentWithSavedCard===>", error.message);
    });
};
export const cancelSubscriptionPlan = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "billing/cancelSubscription",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  cancelSubscriptionPlan===>", error.message);
    });
};

export const updateDefaultCard = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "billing/setDefaultCard", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateDefaultCard===>", error.message);
    });
};
export const cardDelete = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "billing/cardDelete", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  cardDelete===>", error.message);
    });
};

/*<================================SHIPMENT CHARGES============================> */
export const getWeightCharges = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/fetchWeightCharges",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getWeightCharges===>", error.message);
    });
};
export const getPickupCharges = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/fetchPickupCharges",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getPickupCharges===>", error.message);
    });
};
export const getWeightChargesById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/fetchWeightChargesById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getWeightChargesById===>", error.message);
    });
};

export const saveWeightCharges = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/addWeightCharges",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  saveWeightCharges===>", error.message);
    });
};
export const updateWeightCharges = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/updatefetchWeightCharges",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateWeightCharges===>", error.message);
    });
};
export const deleteCargoWeightByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/deleteCargoWeight",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteCargoWeightByID===>", error.message);
    });
};

export const deleteCargoPickupByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/deleteCargoPickup",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteCargoPickupByID===>", error.message);
    });
};

export const getPickupChargesById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/fetchPickupChargesById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getPickupChargesById===>", error.message);
    });
};
export const saveConsignmentPickupCharges = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/addConsignmentPickupCharges",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  saveConsignmentPickupCharges===>", error.message);
    });
};

export const updatefetchPickupChargesByID = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "shipment/updatefetchPickupCharges",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updatefetchPickupChargesByID===>", error.message);
    });
};

/*<==============================================DELIVERY TIME=======================================>*/

export const getDeliveryTime = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "deliveryTime/fetchDeliveryTime",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getDeliveryTime===>", error.message);
    });
};

export const deleteDeliveryTimeByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "deliveryTime/deleteDeliveryTime",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteDeliveryTimeByID===>", error.message);
    });
};
export const getDeliveryTimeById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "deliveryTime/fetchDeliveryTimeById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getDeliveryTimeById===>", error.message);
    });
};

export const saveDeliveryTime = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "deliveryTime/addDeliveryTime",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  saveDeliveryTime===>", error.message);
    });
};
export const updateDeliveryTimeByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "deliveryTime/updateDeliveryTime",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateDeliveryTimeByID===>", error.message);
    });
};

/*<============================= WAREHOUSE =================================>*/

export const fetchWare = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "warehouse/fetchWarehouse",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchWarehouse===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const deleteWarehouseRecords = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "warehouse/deleteWarehouse",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteWarehouse===>", error.message);
    });
};

export const getWarehouseById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "warehouse/fetchWarehouseById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  fetchWarehouseById===>", error.message);
    });
};

export const addWarehouseData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "warehouse/addWarehouse", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addWarehouse===>", error.message);
    });
};

export const updateWarehouseData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "warehouse/updateWarehouse",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateWarehouse===>", error.message);
    });
};

/*<=======================================MY USERS========================>*/

export const fetchUser = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "userSetting/fetchUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error fetchUser===>", error?.response?.data?.Result_Message);
    });
};

export const deleteUserRecords = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "userSetting/deleteUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteWarehouse===>", error.message);
    });
};

export const getMyUserById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "userSetting/fetchUserById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error deete fetchUserById===>", error.message);
    });
};

export const addUserData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "userSetting/addUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addWarehouse===>", error.message);
    });
};

export const fetchReusableTeamMembers = async (
  values,
  callBack,
  errorCallBack
) => {
  await axios
    .post(
      appConstants.baseURL + "userSetting/fetchReusableTeamMembers",
      values,
      axiosConfig
    )
    .then((res) => callBack(res.data))
    .catch((error) => errorCallBack?.(error));
};

export const addExistingTeamMember = async (
  values,
  callBack,
  dispatch,
  errorCallBack
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "userSetting/addExistingTeamMember",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      errorCallBack?.(error);
    });
};

export const updateUserData = async (
  values,
  callBack,
  dispatch,
  errorCallBack
) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "userSetting/updateUser", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      errorCallBack?.(error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateUser===>", error.message);
    });
};

export const fetchRolesData = async (values, callBack, errorCallBack) => {
  await axios
    .post(appConstants.baseURL + "userSetting/fetchRoles", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      errorCallBack?.(error);
      console.log("error  getCountry===>", error.message);
    });
};

/*<=======================================ORDERS===================================================> */

export const getCreditInfo = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchCreditInfo", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getCreditInfo===>", error.message);
    });
};

export const getOrder = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchOrder", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getOrder===>", error.message);
    });
};
export const getWarehouseByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "order/fetchWarehouseByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getWarehouseByID===>", error.message);
    });
};
export const getOrderItems = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchOrderItems", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getOrderItems===>", error.message);
    });
};

export const editOrderforfinal = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "order/editOrderforfinalbyId",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  editOrderforfinal===>", error.message);
    });
};

export const getAddress = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchAddress", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getAddress===>", error.message);
    });
};

export const updateOrderDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "order/updateOrderDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateOrderDetailsByID===>", error.message);
    });
};
export const saveOrder = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/addOrder", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  saveOrder===>", error.message);
    });
};

export const saveOrderItems = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/addOrderItems", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  saveOrderItems===>", error.message);
    });
};
export const updateOrderItemsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/updateOrderItems", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateOrderItemsByID===>", error.message);
    });
};

export const deleteOrderItemsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/deleteOrderItems", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteOrderItemsByID===>", error.message);
    });
};

export const deleteAddressByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/deleteAddress", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteAddressByID===>", error.message);
    });
};

export const getOrderChargesByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/getOrderCharges", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getOrderChargesByID===>", error.message);
    });
};

export const orderStatusUpdateByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/orderStatusUpdate", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  orderStatusUpdateByID===>", error.message);
    });
};
export const getOrderPaymentIntent = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "order/fetchPaymentIntent",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getPaymentIntent===>", error.message);
    });
};

export const getAddressByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchAddressByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getAddressByID===>", error.message);
    });
};

export const addEditCustomerAddress = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/addEditAddress", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addEditCustomerAddress===>", error.message);
    });
};

export const getOrderByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchOrderByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getOrderByID===>", error.message);
    });
};
export const getDriverByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchDriver", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getDriverByID===>", error.message);
    });
};

export const getDropLocation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/fetchDropLocation", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getDriverByID===>", error.message);
    });
};

export const assignJobToDriverByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/assignJobToDriver", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  assignJobToDriverByID===>", error.message);
    });
};

export const reAssignDriverByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/reAssignDriver", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  reAssignDriverByID===>", error.message);
    });
};
export const createGatewayUrlByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/createGatewayUrl", values)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  createGatewayUrlByID===>", error.message);
    });
};

export const updatePaymentStatusByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/updatePaymentStatus", values)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updatePaymentStatusByID===>", error.message);
    });
};
export const getReacherOrderByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "order/fetchReacherOrderByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getReacherOrderByID===>", error.message);
    });
};

export const updateItemStatusByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "order/updateItemStatus", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateItemStatusByID===>", error.message);
    });
};
export const generateOrderQRCodeByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "order/GenerateOrderQRCode",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  generateOrderQRCodeByID===>", error.message);
    });
};

/*<============================ BAT GROUP============================>*/

export const fetchBatGroup = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/fetchBatGroup", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchBatGroup===>", error.message);
    });
};

export const fetchBatVehicle = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/fetchBatVehicle", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchBatVehicle===>", error.message);
    });
};

export const deleteBatGroupRecords = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/deleteBatGroup", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete deleteBatGroup===>", error.message);
    });
};

export const deleteBatVehicleRecords = async (values1, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/deleteBatVehicle", values1, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete deleteBatVehicle===>", error.message);
    });
};

export const getBatGroupById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/fetchBatGroupById", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchBatGroupById===>", error.message);
    });
};

export const addBatGroup = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/addBatGroup", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete deleteBatGroup===>", error.message);
    });
};

export const updateBatGroup = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/updateBatGroup", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete updateBatGroup===>", error.message);
    });
};

export const getBatVehicleById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/fetchBatVehicleById", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchBatGroupById===>", error.message);
    });
};

export const addBatVehicle = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/addBatVehicle", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete addBatVehicle===>", error.message);
    });
};

export const updateBatVehicle = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "bat/updateBatVehicle", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete updateBatGroup===>", error.message);
    });
};

export const fetchRegistrationNumberData = async (values, callBack) => {
  await axios
    .post(
      appConstants.baseURL + "bat/fetchRegistrationNumber",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete fetchRegistrationNumber===>", error.message);
    });
};

export const fetchDetailsByRegistrationData = async (val, callBack) => {
  await axios
    .post(
      appConstants.baseURL + "bat/fetchDetailsByRegistration",
      val,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete fetchDetailsByRegistration===>", error.message);
    });
};

//========> Load Plan Vehicle API ===========//

export const fetchLoadPlanVehicles = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "loadPlanVehicles/fetchLoadPlanVehicles",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchLoadPlanVehicles===>", error.message);
    });
};

export const deleteLoadPlanVehiclesRecords = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "loadPlanVehicles/deleteLoadPlanVehicles",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchLoadPlanVehicles===>", error.message);
    });
};

export const fetchLoadPlanVehiclesByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "loadPlanVehicles/fetchLoadPlanVehiclesByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error delete fetchLoadPlanVehiclesByID===>", error.message);
    });
};

export const fetchWarehouseByID = async (values, callBack) => {
  await axios
    .post(
      appConstants.baseURL + "loadPlanVehicles/fetchWarehouseByID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete fetchWarehouseByID===>", error.message);
    });
};
export const loadVehicleCategoryData = async (values, callBack) => {
  await axios
    .post(
      appConstants.baseURL + "loadPlanVehicles/loadVehicleCategory",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error delete loadVehicleCategory===>", error.message);
    });
};

export const addloadVehicleCategoryData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "loadPlanVehicles/addloadVehicleCategory",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addloadVehicleCategory===>", error.message);
    });
};

export const loadPlanVehiclesUpdateData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "loadPlanVehicles/loadPlanVehiclesUpdate",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  LoadPlanVehiclesUpdate===>", error.message);
    });
};
/*<=================================================PROFILE==================================>*/

export const getUserProfileByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "user/fetchUserProfile", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getUserProfileByID===>", error.message);
    });
};

export const updateUserProfileByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "user/updateUserProfile", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      callBack({
        Result_Status: false,
        Result_Message:
          error.response?.data?.Result_Message ||
          "Unable to update your profile. Please try again.",
      });
    });
};

export const deactivateUserProfile = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "user/deactivateMyProfileUser",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deactivateUserProfile===>", error.message);
    });
};
export const deleteUserProfile = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "user/deleteMyProfileUser",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteUserProfile===>", error.message);
    });
};

/*<====================================CUSTOMER PROFILE=============================>*/

export const getCustomerProfileByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "customer/fetchCustomerProfile",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getCustomerProfileByID===>", error.message);
    });
};

export const updateCustomerByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(appConstants.baseURL + "customer/updateCustomer", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateCustomerByID===>", error.message);
    });
};

/*<===========================================WAREHOUSE DASHBOARD====================================>*/

export const getWarehouseRecieveData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchWarehouseOrderByStatus",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getWarehouseRecieveData===>", error.message);
    });
};

export const getWarehouseOrderForAllocate = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL +
        "warehouseDashboard/fetchWarehouseOrderForAllocate",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getWarehouseOrderForAllocate===>", error.message);
    });
};

export const getWarehouseOrderForFinalDelivery = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL +
        "warehouseDashboard/fetchWarehouseOrderForFinalDelivery",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error  getWarehouseOrderForFinalDelivery===>",
        error.message
      );
    });
};

export const getLoadPlanVehicle = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchLoadPlanVehicle",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getLoadPlanVehicle===>", error.message);
    });
};

export const getDriver = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchDriver",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getDriver===>", error.message);
    });
};

export const getWarehouses = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchWarehouses",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getWarehouses===>", error.message);
    });
};

export const getPrimeMover = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchPrimeMover",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getPrimeMover===>", error.message);
    });
};

export const getOrderItemsWarehouse = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchOrderItemsWarehouse",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getOrderItemsWarehouse===>", error.message);
    });
};

export const recieveOrderByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/recieveOrder",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  recieveOrderByID===>", error.message);
    });
};

export const getSummaryByLoadedVehicleID = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchSummaryByLoadedVehicleID",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getSummaryByLoadedVehicleID===>", error.message);
    });
};

export const getSummaryByLoadType = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchSummaryByLoadType",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getSummaryByLoadType===>", error.message);
    });
};

export const updatPlanLoadStatusByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/updatPlanLoadStatus",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updatPlanLoadStatusByID===>", error.message);
    });
};

export const assignDriverToPrimeByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/assignDriverToPrime",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  assignDriverToPrimeByID===>", error.message);
    });
};

export const getLoadedSlot = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchLoadedSlot",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getLoadedSlot===>", error.message);
    });
};

export const getDroplocation = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/fetchDroplocation",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getDroplocation===>", error.message);
    });
};
export const allocateDriverFinalDeliveryByID = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  console.log("asdasdad", axiosConfig);
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/allocateDriverFinalDelivery",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  allocateDriverFinalDeliveryByID===>", error.message);
    });
};

export const addLoadVehicleAndSlotByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "warehouseDashboard/addLoadVehicleAndSlot",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addLoadVehicleAndSlotByID===>", error.message);
    });
};

//Integration API from Karan Code
export const fetchDefaultSettings = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));

  axios
    .post(
      appConstants.baseURL + "defaultSettings/fetchDefaultSetting",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchDefaultSettings===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const updateDefaultSettingData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "defaultSettings/updateDefaultSetting",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(CurrencyAction(res.data.Result_Output?.currencyValue));
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateItemCategoriesData===>", error.message);
    });
};

export const getCurrencyCode = async (values, callBack) => {
  return axios
    .post(
      appConstants.baseURL + "defaultSettings/fetchDefaultSettingCurrency",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
    })
    .catch((error) => {
      console.log("error  getCurrencyCode===>", error.message);
    });
};

// =========================================Items API ================================

export const fetchItems = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "items/fetchData", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchItems===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const deleteItems = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "items/deleteItemdata", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteUser===>", error.message);
    });
};
export const fetchCategory = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "items/CategoriesData", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchCategory===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const addCatalogueItemData = async (
  values,
  callBack,
  dispatch,
  { showLoader = true } = {}
) => {
  if (showLoader) dispatch(loadingAction(true));
  try {
    const [categoriesResponse, gstResponse] = await Promise.all([
      axios.post(
        appConstants.baseURL + "items/fetchCategoriesData",
        { businessUserID: values.businessUserID },
        axiosConfig
      ),
      axios.post(
        appConstants.baseURL + "items/fetchParameterValue",
        {},
        axiosConfig
      ),
    ]);
    const category = categoriesResponse.data.fetchCategories?.find(
      (item) =>
        item.categoryName === values.categoryName ||
        item.categoryCodeName === values.categoryCodeName
    );
    const gstRate = Number(values.gst);
    const gst = gstResponse.data.Result_Output?.[0]?.list?.find(
      (item) => Number(item.customValue1 ?? item.parameterListName) === gstRate
    );
    if (!category?._id || !gst?._id) {
      callBack({
        Result_Status: false,
        Result_Message:
          "The selected account or GST rate is unavailable. Please check catalogue settings.",
      });
      return;
    }

    const response = await axios.post(
      appConstants.baseURL + "items/addItemData",
      {
        ...values,
        categoryID: category._id,
        gst: gst._id,
        unitOfMeasurement: values.unit || "each",
      },
      axiosConfig
    );
    const data = response.data;
    callBack(
      data.Result_Status && data.Result_Output
        ? {
            ...data,
            Result_Output: {
              ...data.Result_Output,
              gst: gstRate,
              categoryCodeName:
                category.categoryCodeName || values.categoryCodeName,
            },
          }
        : data
    );
    dispatch(IdleAction(new Date()));
  } catch (error) {
    if (error?.response?.data?.Result_Message === "TokenExpiredError")
      generateToken(id, dispatch);
    callBack({
      Result_Status: false,
      Result_Message:
        error?.response?.data?.Result_Message ||
        "Unable to save the catalogue item. Please try again.",
    });
  } finally {
    if (showLoader) dispatch(loadingAction(false));
  }
};

export const updateCatalogueItemData = async (
  values,
  callBack,
  dispatch,
  { showLoader = true } = {}
) => {
  if (showLoader) dispatch(loadingAction(true));
  try {
    const [categoriesResponse, gstResponse] = await Promise.all([
      axios.post(
        appConstants.baseURL + "items/fetchCategoriesData",
        { businessUserID: values.businessUserID },
        axiosConfig
      ),
      axios.post(
        appConstants.baseURL + "items/fetchParameterValue",
        {},
        axiosConfig
      ),
    ]);
    const category = categoriesResponse.data.fetchCategories?.find(
      (entry) =>
        entry.categoryName === values.categoryName ||
        entry.categoryCodeName === values.categoryCodeName
    );
    const gstRate = Number(values.gst);
    const gst = gstResponse.data.Result_Output?.[0]?.list?.find(
      (entry) =>
        Number(entry.customValue1 ?? entry.parameterListName) === gstRate
    );
    if (!category?._id || !gst?._id) {
      callBack({
        Result_Status: false,
        Result_Message:
          "The selected account or GST rate is unavailable. Please check catalogue settings.",
      });
      return;
    }

    const response = await axios.post(
      appConstants.baseURL + "items/updateItems",
      {
        ...values,
        categoryID: category._id,
        categoryName: category.categoryCodeName || category.categoryName,
        gst: gst._id,
        unitOfMeasurement: values.unit || "each",
      },
      axiosConfig
    );
    callBack(response.data);
    dispatch(IdleAction(new Date()));
  } catch (error) {
    if (error?.response?.data?.Result_Message === "TokenExpiredError")
      generateToken(id, dispatch);
    callBack({
      Result_Status: false,
      Result_Message:
        error?.response?.data?.Result_Message ||
        "Unable to update the catalogue item. Please try again.",
    });
  } finally {
    if (showLoader) dispatch(loadingAction(false));
  }
};

export const addItemsData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "items/addItemData", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addItemCategoriesData===>", error.message);
    });
};

export const updateItemsData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "items/updateItems", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateItemCategoriesData===>", error.message);
    });
};

export const getItemsById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "items/fetchItemsById", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  getItemsById===>", error.message);
    });
};
// ======================================= categories API========================

export const fetchCategories = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "itemCategries/screenData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchCategories===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const addItemCategoriesData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "itemCategries/addData", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addItemCategoriesData===>", error.message);
    });
};

export const updateItemCategoriesData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "itemCategries/updateItemCategories",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateItemCategoriesData===>", error.message);
    });
};
export const getItemCategoriesById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "itemCategries/fetchItemCategoriesById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  fetchWarehouseById===>", error.message);
    });
};

export const deleteItemCategories = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "itemCategries/deleteCategories",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteUser===>", error.message);
    });
};
/////////////////////////////Expenses API////////////////////////
export const fetchedExpenses = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "expenses/fetchExpensesData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      // console.log("reeeeeee",res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchExpenses===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const getExpensesById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "expenses/fetchExpenseById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  fetchWarehouseById===>", error.message);
    });
};

export const addExpensesData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + "expenses/addExpenses", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(IdleAction(new Date()));
      dispatch(loadingAction(false));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  addExpensesData===>", error.message);
    });
};

export const fetchCategoriess = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "expenses/CategoriesData", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchCategories===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const updateExpenseData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + "expenses/updateExpense", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateItemCategoriesData===>", error.message);
    });
};

export const recordExpensePayment = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  return axios
    .post(appConstants.baseURL + "expenses/recordPayment", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      callBack(
        error?.response?.data || {
          Result_Status: false,
          Result_Message: "Payment could not be recorded. Try again.",
          Result_Output: [],
        }
      );
    });
};

export const deleteExpenses = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "expenses/deleteExpense", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteExpense===>", error.message);
    });
};

/*<===============================INVOICE REMINDER TEMPLATE==============================>*/

export const fetchInvoiceReminderTemplate = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminder/fetchInvoiceReminderTemplate",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log(
        "error fetchInvoiceReminderTemplate===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchInvoiceReminderById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminder/fetchInvoiceReminderById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error  fetchInvoiceReminderById===>", error.message);
    });
};
export const fetchLegalDocumentFormat = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminder/fetchLegalDocumentFormat",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error  fetchInvoiceReminderById===>", error.message);
    });
};
export const addInvoiceReminderData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminder/addInvoiceReminder",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error  addInvoiceReminderData===>", error.message);
    });
};

export const updateInvoiceReminder = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminder/updateInvoiceReminder",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error  updateInvoiceReminder===>", error.message);
    });
};

export const deleteinvoiceReminder = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminder/deleteInvoiceReminderTemplate",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  deleteInvoiceReminder===>", error.message);
    });
};

/*<===========================Report: Invoice Reminder Logs API========================>*/

export const fetchInvoiceReminderLogs = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminderLogs/fetchInvoiceReminderLogs",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchInvoiceReminderLogs===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const fetchContacts = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReminderLogs/fetchInvoiceReminderContacts",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchContacts===>",
        error?.response?.data?.Result_Message
      );
    });
};

/*<===========================Report: Aged Receivables Summary API========================>*/

export const fetchAgedReceivables = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "agedReceivables/fetchAgedReceivables",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchAgedReceivables===>",
        error?.response?.data?.Result_Message
      );
    });
};

/*<===========================Report: Aged Payables Summary API========================>*/

export const fetchAgedPayables = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "agedPayables/fetchAgedPayables",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchAgedPayables===>",
        error?.response?.data?.Result_Message
      );
    });
};
//<===========================Report: Legal Documents S_Admin API========================>
export const getLegalDocumets = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/fetchLegalDocumentsFormats",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);

      console.log(
        "error getLegalDocumetsFormats===>",
        error?.response?.data?.Result_Message
      );
    });
};
export const uploadLegalDocumentsFormat = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/uploadLegalDocumentsFormats",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);

      console.log(
        "Error upload LegalDocuments Format: ",
        error?.response?.data?.Result_Message
      );
    });
};
export const deleteLegalDocumentFormat = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "parameterSetting/deleteDocument",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);

      console.log(
        "Error Delete LegalDocumets Formats: ",
        error?.response?.data?.Result_Message
      );
    });
};

/*<===========================Report:Quotation Report  API========================>*/

export const fetchQuotationReportData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "quotationReport/fetchQuotationReportData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchQuotationReportData===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchQuotationContacts = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "quotationReport/fetchQuotationContacts",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchQuotationContacts===>",
        error?.response?.data?.Result_Message
      );
    });
};

/*<===========================Report:Invoice Report  API========================>*/

export const fetchInvoiceReportData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReport/fetchInvoiceReportData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchInvoiceReportData===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchInvoiceContacts = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReport/fetchInvoiceContacts",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchQuotationContacts===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchItemsForReport = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoiceReport/fetchItemsForReport",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchItemsForReport===>",
        error?.response?.data?.Result_Message
      );
    });
};
/*<===========================Report:RCTI Report  API========================>*/

export const fetchRCTIReportData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "rctiReport/fetchRCTIReportData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchRCTIReportData===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchRCTIContacts = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "rctiReport/fetchRCTIContacts",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchRCTIContacts===>",
        error?.response?.data?.Result_Message
      );
    });
};

// **<===========================Contacts Report API========================>**
export const fetchContactReportDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "contactReport/fetchContactReportDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchContactReportDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};

// **<===========================Expenses Report API========================>**
export const fetchExpensesReportDetails = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "expensesReport/fetchExpensesReportDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchExpensesReportDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};

// Invoice PDF Format API◘
export const addInvoicePdfFormat = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/addInvoicePdfFormat",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error addInvoicePdfFormat===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchInvoicePdfFormat = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/fetchInvoicePdfFormat",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchInvoicePdfFormat===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const fetchInvoicePdfTheme = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  await axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/fetchInvoicePdfTheme",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchInvoicePdfTheme===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const downloadInvoice = async (values, callback, dispatch) => {
  if (typeof values._id === "string")
    return downloadWebsiteDocument("invoice", values, callback, dispatch);
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/downloadInvoice",
      values,
      axiosConfig
    )
    .then((res) => {
      callback(res);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error downloadInvoice===>",
        error?.response?.data?.Result_Message
      );
      console.log(error);
    });
};

export const getInvoicePdfFormatById = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/fetchInvoicePdfFormatById",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  fetchInvoicePdfFormatById===>", error.message);
    });
};

export const updateInvoicePdfFormatData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/updateInvoicePdfFormat",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(CurrencyAction(res.data.Result_Output?.currencyValue));
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error  updateInvoicePdfFormatData===>", error.message);
    });
};

export const deleteInvoicePdfFormatData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "invoicePdfFormat/deleteInvoicePdfFormat",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch);
      console.log("error delete deleteInvoicePdfFormat===>", error.message);
    });
};

// ------------------- Business User Dashborad 22-------------------------

export const getBusinessUserCustomerGridData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL +
        "businessUserDashboard/fetchBusinessUserCustomerGridData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getBusinessUserCustomerGridData===>", error);
    });
};

export const getBusinessUserDashboardCardData = async (
  values,
  callBack,
  dispatch
) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL +
        "businessUserDashboard/fetchBusinessUserDashboardCardData",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getBusinessUserDashboardCardData===>", error);
    });
};
export const addBuRole = async (values, callBack, dispatch, errorCallBack) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "roles/addBuRole", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      errorCallBack?.(error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getBusinessUserDashboardCardData===>", error);
    });
};
export const fetchBURoleByID = async (
  values,
  callBack,
  dispatch,
  errorCallBack
) => {
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "roles/fetchBURoleByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      errorCallBack?.(error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getBusinessUserDashboardCardData===>", error);
    });
};
export const updateBuRole = async (
  values,
  callBack,
  dispatch,
  errorCallBack
) => {
  dispatch(loadingAction(true));

  axios
    .post(appConstants.baseURL + "roles/updateBuRole", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      errorCallBack?.(error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error getBusinessUserDashboardCardData===>", error);
    });
};
//activtyLog
export const fetchActivityLog = async (
  values,
  callBack,
  dispatch,
  errorCallBack
) => {
  dispatch(loadingAction(true));
  return axios
    .post(
      appConstants.baseURL + "activityLog/fetchActivityLog",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
      return res.data;
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchActivityLog===>",
        error?.response?.data?.Result_Message
      );
      if (typeof errorCallBack === "function") errorCallBack(error);
      return null;
    });
};
export const saveNotes = async (values, callBack, dispatch) => {
  console.log("SSSS", values);
  dispatch(loadingAction(true));
  axios
    .post(appConstants.baseURL + "activityLog/saveNotes", values, axiosConfig)
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error saveNotes===>", error.message);
    });
};

export const fetchItemReportDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "items/fetchItemReportDetails",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch(async (error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log(
        "error fetchItemReportDetails===>",
        error?.response?.data?.Result_Message
      );
    });
};

export const sendFeedback = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios
    .post(
      appConstants.baseURL + "activityLog/sendFeedback",
      values,
      axiosConfig
    )
    .then((res) => {
      callBack(res.data);
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    })
    .catch((error) => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError")
        generateToken(id, dispatch);
      console.log("error sendFeedback===>", error.message);
    });
};
